import { Info } from "@phosphor-icons/react"

import { Icon } from "@tokenterminal/core/ui/icon/Icon"

import { Tooltip } from "@tokenterminal/core/ui/overlays/tooltip/Tooltip"

import useMetricsConfigurationBySlug from "modules/projects/OverviewTab/useMetricsConfigurationBySlug"
import Link from "next/link"
import { toSlug } from "../utils"

type MetricTooltipProps =
  | {
      metricSlug: string
      children: React.ReactNode
    }
  | {
      metricId: string
      children: React.ReactNode
    }

const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

const MetricTooltip = (props: MetricTooltipProps) => {
  let slug: string
  let id: string
  if ("metricSlug" in props) {
    slug = props.metricSlug
    id = props.metricSlug
  } else {
    slug = toSlug(props.metricId)
    id = props.metricId
  }
  const metricConfiguration = useMetricsConfigurationBySlug(slug)

  return (
    <Tooltip
      content={
        <div className="flex gap-2 p-2">
          <Icon as={Info} className="w-3 h-3 mt-px text-fg-secondary" />
          <div className="flex flex-col gap-1">
            <div>
              <div className="text-xs font-medium">
                {metricConfiguration?.title}
              </div>
              <div className="text-xs text-fg-secondary max-w-[200px] mt-px">
                {capitalizeFirstLetter(metricConfiguration?.definition || "")}
              </div>
            </div>
            <Link href={`/metrics/${slug}`} className="text-xs text-fg-blue">
              Learn more
            </Link>
          </div>
        </div>
      }
      tooltipProps={{
        className: "rounded-lg p-0",
      }}
    >
      <Tooltip.Trigger>
        <div className="border-b border-dotted border-b-fg-secondary/50">
          {props.children}
        </div>
      </Tooltip.Trigger>
    </Tooltip>
  )
}

export default MetricTooltip
